// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2738":"52bf97b2d3641561","2888":"a5461a543a864d8c","9886":"52bf97b2d3641561"}[chunkId] + ".css";
};